import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'compactCurrency',
  standalone: false,
  pure: true
})
export class CompactCurrencyPipe implements PipeTransform {
  /**
   * Always formats numbers as thousands (k).
   * Examples: 950 -> 0.95k, 1200 -> 1.2k, 0 -> 0k, -500 -> -0.5k
   *
   * @param value number | string | null | undefined — input value
   * @param decimals number — digits after decimal for k values (default 2)
   * @param suffix string — suffix for thousands (default 'k')
   * @param spaceBeforeSuffix boolean — include a space before suffix (default false -> '1.2k')
   * @param locale string — locale for digits/decimal/grouping (default 'en-US')
   * @param trimTrailingZeros boolean — remove trailing .0 (default true -> '1k' instead of '1.00k')
   */
  transform(
    value: number | string | null | undefined,
    decimals = 0,
    suffix = 'k',
    spaceBeforeSuffix = false,
    locale: string = 'en-US',
    trimTrailingZeros = true
  ): string {
    if (value === null || value === undefined || value === '') return '';
    const num = Number(value);
    if (Number.isNaN(num)) return '';

    const kVal = num / 1000;

    // Format with requested decimals
    let formatted = kVal.toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals
    });

    // Optionally trim trailing zeros like "1.00" -> "1", "1.50" -> "1.5"
    if (trimTrailingZeros && decimals > 0) {
      // This is a locale-aware-ish cleanup: handles '.' or ',' decimals in many locales
      // 1) remove trailing zeros after decimal separator
      // 2) remove decimal separator if nothing remains after it
      const decimalSep = (1.1).toLocaleString(locale).replace(/\d/g, '')[0] || '.';
      const parts = formatted.split(decimalSep);
      if (parts.length === 2) {
        parts[1] = parts[1].replace(/0+$/, '');
        formatted = parts[1].length ? parts.join(decimalSep) : parts[0];
      }
    }

    const sep = spaceBeforeSuffix ? ' ' : '';
    return `${formatted}`; //${sep}${suffix}
  }
}